module.exports = __webpack_public_path__ + "static/media/blog-11.4faad448.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blog-11.webp
// module id = 279
// module chunks = 0